import { SimpleSelect, type SimpleSelectProps } from '@retailer-platform/shared-components'
import React, { type FunctionComponent, useEffect } from 'react'
import { useDomainMessages } from 'domains/products/utils/domain/intl'
import { SourceLevel } from 'domains/products/api'
import { useGetProductSourceOptions } from 'domains/products/components/view/utils/useGetProductSourceOptions.hooks'

interface ProductSourcesSelectProps extends Omit<SimpleSelectProps<string>, 'options'> {
  onLoadingError: () => void
}

export const sourcesSelectAriaLabel = 'source-options-dropdown'

export const ProductSourcesSelect: FunctionComponent<ProductSourcesSelectProps> = props => {
  const { sourceOptions, sourceOptionsError, sourceOptionsLoading } = useGetProductSourceOptions(
    SourceLevel.SourceLevelRetailerProduct
  )
  useEffect(() => {
    if (sourceOptionsError) {
      props.onLoadingError()
    }
  }, [sourceOptionsError, props])

  const messages = useDomainMessages({
    sourcesSelectPlaceholder: 'productsDomain.attributeOverride.sources.placeholder',
  })

  return (
    <SimpleSelect
      isModernTheme
      placeholder={messages.sourcesSelectPlaceholder}
      options={sourceOptions}
      loading={sourceOptionsLoading}
      aria-label={sourcesSelectAriaLabel}
      value={props.value}
      onChange={props.onChange}
      {...props}
    />
  )
}
